import {
  LabSelectionWidget,
  UserSelectionWidget,
} from "components/FormWidget";

const uiSchema = () => ({
  lab_ids: {
    "ui:widget": LabSelectionWidget,
  },
  doctor_ids: {
    "ui:widget": UserSelectionWidget,
    "ui:options": {
      initFilter: {
        type_ids: ["2", "3"],
      },
    },
  },
});

export default uiSchema;
